import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { computed } from '@ember/object';

export default class IndexController extends Controller {
  @service messageSettings;
  @service environment;

  urlParams = [];

  @computed('model.hasDirtyAttributes')
  get isDirty() {
    return this.model.hasDirtyAttributes;
  }
}
